import { Category } from '@/app/cv/constants/products/category';
import {
  BuyingTools,
  NavigationMenuLabel,
  NavigationMenuLabelLcs,
  NavigationMenuLabelLcsGroup,
} from '@/app/cv/constants/top-navigation';
import { EURO3_FRR_210_190 } from '@/app/cv/contents/products/euro-3/models';
import {
  EURO5_FRR,
  EURO5_FRR_MIXER,
  EURO5_FTR,
  EURO5_FTR_TRACTOR,
  EURO5_FVM,
  EURO5_FVZ,
  EURO5_FXZ,
  EURO5_FXZ_MIXER,
  EURO5_FYH,
  EURO5_GXZ,
  EURO5_NLR,
  EURO5_NMR,
  EURO5_NMR_MIXER,
  EURO5_NPR,
  EURO5_NPR_MINI_BUS,
  EURO5_NQR,
} from '@/app/cv/contents/products/euro-5/models';
import type { CvEngineModelType } from '@/app/cv/types/top-navigation';
import type {
  MenuLinkType,
  NavItemType,
  NavMenuItemType,
} from '@/app/types/top-navigation';
import type { CvEngineType } from '@/services/contentstack/models/global-fields/cv-engine-type';

export const NAV_BUYING_TOOLS: MenuLinkType[] = [
  {
    label: BuyingTools.searchAndCompare,
    href: '/product',
  },
  {
    label: BuyingTools.dealer,
    href: '/dealer',
  },
  {
    label: BuyingTools.downloadBrochure,
    href: '/download-brochure',
  },
  {
    label: BuyingTools.sellSecondHandCar,
    href: '/register/sell-your-truck',
  },
];

export const SERVICE_AND_OFFER_MENUS = [
  {
    label: 'my-ISUZU',
    href: '/privileges/my-isuzu',
  },
  {
    label: 'สมาชิก “อีซูซุเอลฟ์ ยิ่งเข้า ยิ่งคุ้ม”',
    href: '/privileges/ying-kao-ying-koom-elf',
  },
  {
    label: 'รายการบำรุงรักษาตามระยะ',
    href: '/service/maintenance-list',
  },
  {
    label: 'บริการรถปิกอัพและอเนกประสงค์',
    href: 'https://www.isuzu-tis.com/service/service-center',
    target: '_blank',
  },
];
const NAV_SERVICE_AND_OFFER_MENUS: NavMenuItemType[] = [
  {
    children: SERVICE_AND_OFFER_MENUS,
  },
];

export const LCS_GROUP_BUY = [
  {
    label: NavigationMenuLabelLcs.showroom,
    href: '/dealer',
  },
  {
    label: NavigationMenuLabelLcs.leasing,
    href: '/lcs/isuzuleasing',
  },
  {
    labelHtml: NavigationMenuLabelLcs.rbsc,
    href: '/lcs/rbsc',
  },
];

export const LCS_GROUP_COST = [
  {
    labelHtml: NavigationMenuLabelLcs.ilsc,
    href: '/lcs/ilsc',
  },
  {
    label: NavigationMenuLabelLcs.teletec,
    href: '/lcs/teletec',
  },
  {
    label: NavigationMenuLabelLcs.parts,
    href: '/lcs/parts',
  },
];

export const LCS_GROUP_SERVICE = [
  {
    label: NavigationMenuLabelLcs.service,
    href: '/lcs/service-center',
  },
  {
    label: NavigationMenuLabelLcs.care,
    href: '/lcs/isuzu-care',
  },
  {
    label: NavigationMenuLabelLcs.serviceline,
    href: '/lcs/truck-serviceline',
  },
];
export const LCS_GROUP_SELL = [
  {
    label: NavigationMenuLabelLcs.truck2hand,
    href: '/lcs/truck2hand',
  },
];
export const LCS_GROUP_OVERVIEW = [
  {
    label: NavigationMenuLabel.lcs,
    href: '/lcs',
  },
];
export const NAV_LCS_MENUS: NavMenuItemType[] = [
  {
    title: 'ดูข้อมูล',
    children: LCS_GROUP_OVERVIEW,
  },
  {},
  {
    title: NavigationMenuLabelLcsGroup.buy,
    children: LCS_GROUP_BUY,
  },
  {
    title: NavigationMenuLabelLcsGroup.cost,
    children: LCS_GROUP_COST,
  },
  {
    title: NavigationMenuLabelLcsGroup.service,
    children: LCS_GROUP_SERVICE,
  },

  {
    title: NavigationMenuLabelLcsGroup.sell,
    children: LCS_GROUP_SELL,
  },
];

export const SHARE_MENUS = [
  {
    label: 'เรื่องราวจากผู้ใช้อีซูซุ',
    href: '/content-hub/experiences',
  },
  {
    label: 'เรื่องน่ารู้จากอีซูซุ',
    href: '/content-hub/expert',
  },
  {
    label: 'แกลเลอรี่',
    href: '/content-hub/inspiration',
  },
];
const NAV_SHARE_MENUS: NavMenuItemType[] = [
  {
    children: SHARE_MENUS,
  },
];

export const NAV_MENUS: NavItemType[] = [
  {
    label: NavigationMenuLabel.model,
    modelMenu: 'cv',
  },
  {
    label: BuyingTools.title,
    isOnlyMobileNav: true,
    items: [
      {
        children: NAV_BUYING_TOOLS,
      },
    ],
  },
  {
    label: NavigationMenuLabel.offer,
    href: '/specialoffer',
  },
  {
    label: NavigationMenuLabel.lcs,
    items: NAV_LCS_MENUS,
  },
  {
    label: NavigationMenuLabel.serviceAndOffer,
    items: NAV_SERVICE_AND_OFFER_MENUS,
  },
  {
    label: NavigationMenuLabel.share,
    items: NAV_SHARE_MENUS,
  },
];

export const CATEGORY_LABELS: Record<CvEngineType, Record<string, string>> = {
  'euro-5': {
    [Category.TRUCK_TRACTOR]: 'หัวลาก',
    [Category.TRUCK_12_WHEELS]: '12 ล้อ',
    [Category.TRUCK_10_WHEELS]: '10 ล้อ',
    [Category.TRUCK_6_WHEELS]: '6 ล้อ',
    [Category.TRUCK_4_WHEELS]: '4 ล้อ',
    [Category.TRUCK_MIXER]: 'ผสมปูน',
    [Category.TRUCK_MINIBUS_CHASSIS]: 'มินิบัส แชสซีส์',
  },
  'euro-3': {
    [Category.TRUCK_6_WHEELS]: '6 ล้อ',
  },
};

export const CATEGORY_MODEL_TITLE = {
  [Category.TRUCK_TRACTOR]: {
    tracktor10: 'หัวลาก 10 ล้อ',
    tracktor6: 'หัวลาก 6 ล้อ',
  },
  [Category.TRUCK_10_WHEELS]: {
    axle2: 'สองเพลา',
    axle1: 'เพลาเดียว',
  },
  [Category.TRUCK_6_WHEELS]: {
    large: 'ขนาดใหญ่',
    middle: 'ขนาดกลาง',
  },
};

export const NAV_CV_ENGINE_MODELS: CvEngineModelType = {
  'euro-5': {
    [Category.TRUCK_TRACTOR]: {
      items: [
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_TRACTOR].tracktor10,
          items: [EURO5_GXZ],
        },
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_TRACTOR].tracktor6,
          items: [EURO5_FTR_TRACTOR],
        },
      ],
    },
    [Category.TRUCK_12_WHEELS]: {
      items: [
        {
          items: [EURO5_FYH],
        },
      ],
    },
    [Category.TRUCK_10_WHEELS]: {
      items: [
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_10_WHEELS].axle2,
          items: [EURO5_FXZ, EURO5_FVZ],
        },
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_10_WHEELS].axle1,
          items: [EURO5_FVM],
        },
      ],
    },
    [Category.TRUCK_6_WHEELS]: {
      isSeparateCategory: true,
      items: [
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_6_WHEELS].large,
          items: [EURO5_FTR],
        },
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_6_WHEELS].middle,
          items: [EURO5_FRR, EURO5_NQR, EURO5_NPR, EURO5_NMR],
        },
      ],
    },
    [Category.TRUCK_4_WHEELS]: {
      items: [
        {
          items: [EURO5_NLR],
        },
      ],
    },
    [Category.TRUCK_MIXER]: {
      items: [
        {
          items: [EURO5_FXZ_MIXER, EURO5_FRR_MIXER, EURO5_NMR_MIXER],
        },
      ],
    },
    [Category.TRUCK_MINIBUS_CHASSIS]: {
      items: [
        {
          items: [EURO5_NPR_MINI_BUS],
        },
      ],
    },
  },
  'euro-3': {
    [Category.TRUCK_6_WHEELS]: {
      isSeparateCategory: true,
      items: [
        {
          title: CATEGORY_MODEL_TITLE[Category.TRUCK_6_WHEELS].middle,
          items: [EURO3_FRR_210_190],
        },
      ],
    },
  },
};
